// One show delay for every tooltip: the shared element tooltip (v-wp-tooltip) and the AG Grid
// header / cell tooltips (the grids pass it as `tooltipShowDelay`), so they feel the same.
export const TOOLTIP_SHOW_DELAY_MS = 1000;
